import StoreTags from '@enums/StoreTags'
import { CommonQueryParams, ItemsFromResponse } from '@models/common'
import {
  CreateMultipleRiskMapJobPositions,
  RiskMapJobPosition,
  RiskMapJobPositionDetailed,
  RiskMapJobPositionOption,
  UpdateRiskMapJobPositionBody,
} from '@models/riskMapJobPosition'
import { FetchArgs } from '@reduxjs/toolkit/dist/query/react'
import emptySplitApi from '../api'
import { HYDRA_MEMBER, HYDRA_TOTAL_ITEMS } from '../../config/consts'

const BASE_URL = '/api/risk_map_job_positions'

export const RiskMapJobPositionsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRiskMapJobPositions: builder.query<
      { items: RiskMapJobPositionOption[]; length: number },
      CommonQueryParams
    >({
      query: (params) => ({
        url: BASE_URL,
        params,
      }),
      transformResponse: (response: ItemsFromResponse<RiskMapJobPosition>) => ({
        items: response[HYDRA_MEMBER].map((item) => ({
          ...item,
          label: item.title,
          value: item['@id'],
        })),
        length: response[HYDRA_TOTAL_ITEMS],
      }),
      providesTags: [StoreTags.RISK_MAP_JOB_POSITIONS],
    }),
    uploadRiskMapPositionsDictionary: builder.mutation<
      void,
      { file: string } // iri
    >({
      invalidatesTags: (result) =>
        result ? [StoreTags.RISK_MAP_JOB_POSITIONS] : [],
      query: (body): FetchArgs => ({
        url: BASE_URL + '/upload_dictionary',
        method: 'POST',
        body,
      }),
    }),
    createMultipleRiskMapPositions: builder.mutation<
      void,
      CreateMultipleRiskMapJobPositions
    >({
      invalidatesTags: (result) =>
        result ? [StoreTags.RISK_MAP_JOB_POSITIONS] : [],
      query: (body): FetchArgs => ({
        url: BASE_URL + '/multiple',
        method: 'POST',
        body,
      }),
    }),
    getRiskMapPosition: builder.query<RiskMapJobPositionDetailed, number>({
      providesTags: [StoreTags.RISK_MAP_JOB_POSITION],
      query: (id) => `${BASE_URL}/${id}`,
    }),
    updateRiskMapPosition: builder.mutation<void, UpdateRiskMapJobPositionBody>(
      {
        invalidatesTags: (result) =>
          result
            ? [
                StoreTags.RISK_MAP_JOB_POSITIONS,
                StoreTags.RISK_MAP_JOB_POSITION,
              ]
            : [],
        query: ({ id, ...body }) => ({
          url: `${BASE_URL}/${id}`,
          method: 'PUT',
          body,
        }),
      }
    ),
    deleteRiskMapPosition: builder.mutation<void, number>({
      invalidatesTags: [StoreTags.RISK_MAP_JOB_POSITIONS],
      query: (id) => ({
        url: `${BASE_URL}/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useGetRiskMapJobPositionsQuery,
  useUploadRiskMapPositionsDictionaryMutation,
  useCreateMultipleRiskMapPositionsMutation,
  useGetRiskMapPositionQuery,
  useDeleteRiskMapPositionMutation,
  useUpdateRiskMapPositionMutation,
  useLazyGetRiskMapPositionQuery,
} = RiskMapJobPositionsApi
